<ul class="pcg-search-result-list">
    <li *ngFor="let item of searchResult.pageItems" class="pcg-search-result-list__item">
        <pcg-ng-directory-item-details-card
            [itemToDisplay]="item"
            [viewPageUrl]="viewPageUrl"
            [defaultImageUrl]="defaultImageUrl">
        </pcg-ng-directory-item-details-card>
    </li>
</ul>
